import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { useMediaQuery } from 'hooks/useMediaQuery';

const RADIAN = Math.PI / 180;

const calculateXPosition = (no, pos) => {
    const length = no?.toString()?.length;
    const factor = 6;
    
    let xPos = pos === 1 ? 43 : pos === 2 ? 51 : 57;
    if (length <= 2 || (pos === 2 && length === 2)) return xPos;
    
    if (pos === 1) {
        return xPos - factor;
    }
    
    if (pos === 2) {
        return xPos + (factor / 2);
    }
    
    return xPos + factor;
} 

const OnDemandPayEmployeesChart = ({ odpData }) => {
    const isTablet = useMediaQuery('(min-width: 1024px) and (max-width: 1350px)');
    const isSmallMobile = useMediaQuery('(max-width: 450px)');
    const isSmallerMobile = useMediaQuery('(max-width: 380px)');
    const isReallySmallMobile = useMediaQuery('(max-width: 300px)');
    const data = [
        { name: 'Entrolled', value: odpData?.enrolled, color: '#00535C' },
        { name: 'Not Enrolled', value: odpData?.notEnrolled ? odpData?.notEnrolled : 1, color: '#E5E7EB' },
    ];
    
    return (
        <div className="flex justify-center items-center">
            <div style={{ width: '100%', height: '200px' }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            dataKey="value"
                            startAngle={180}
                            endAngle={0}
                            data={data}
                            cx="50%"
                            cy={isReallySmallMobile ? "60%" : isSmallerMobile ? "70%" : "100%"}
                            innerRadius={isTablet ? "120%" : isReallySmallMobile ? "50%" : isSmallerMobile ? "80%" : isSmallMobile ? "100%" : "140%"}
                            outerRadius={isTablet ? "180%" : isReallySmallMobile ? "90%" : isSmallerMobile ? "120%" : isSmallMobile ? "150%" : "200%"}
                            cornerRadius={10}
                            fill="#8884d8"
                            stroke="none"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <text
                            x="50%"
                            y="70%"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            className='font-normal tracking-wider'
                            style={{ 
                                fontSize: isSmallerMobile ? "15px" : isSmallMobile ? "12px" : "14px" 
                            }}
                            fill='#615E83'
                        >
                            Enrolled Employees
                        </text>
                        <text
                            x={`${calculateXPosition(odpData?.enrolled, 1)}%`}
                            y="90%"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            className='font-bold'
                            style={{ 
                                fontSize: isSmallerMobile ? "16px" : isSmallMobile ? "22px" : "31.5px" 
                            }}
                        >
                            {odpData?.enrolled}
                        </text>
                        <text
                            x={`${calculateXPosition(odpData?.enrolled, 2)}%`}
                            y="90%"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            className='font-bold'
                            style={{ 
                                fontSize: isSmallerMobile ? "16px" : isSmallMobile ? "22px" : "31.5px" 
                            }}
                        >
                            /
                        </text>
                        <text
                            x={`${calculateXPosition(odpData?.enrolled)}%`}
                            y="90%"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            className='font-bold mt-2'
                            fill='#718096'
                            style={{ 
                                fontSize: isSmallerMobile ? "12px" : isSmallMobile ? "15px" : "17.5px" 
                            }}
                        >
                            {odpData?.notEnrolled}
                        </text>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default OnDemandPayEmployeesChart;